import { createContext, Dispatch, useContext } from "react";
import { Graph_QL, MaintainAnimal } from "../../../Services";
import { Location } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall"
/* eslint-disable */
enum IPenContextEnum {
  currentViewType = "currentViewType",
  tempData = "tempData",
  replaceTempData = "replaceTempData",
  error = "error",
  pens = "pens",
  systemState = "systemState"
}

export enum currentViewTypes {
  basic = "basic",
  edit = "edit",
  add = "add",
  move = "move"
}

export enum LocationListTypes {
  animals = "animals",
  pens = "pens"
}
/* eslint-enable */

export interface ChangedAnimalData {
  penId: number, animalId: number,
  data: Omit<MaintainAnimal, "animal_id">,
}

export type IPenContext = {
  farm: string;
  domain: string;
  connection: Graph_QL.Connection;
  systemType: number;
  currentViewType: currentViewTypes;
  pens: Location[]
  tempData: ChangedAnimalData[];
  error: { Elementid: number, errorText: string };
};

export type PenDispatcherT = Deep_Partial<IPenContext> & { replaceTempData?: ChangedAnimalData[] };
type PenContexter = {
  state: IPenContext,
  dispatch: Dispatch<PenDispatcherT>
}

export const PenContext = createContext<PenContexter | undefined>(undefined);
export function PenReducer(state: IPenContext, action: PenDispatcherT) {
  let ResultState = state;
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case IPenContextEnum.currentViewType:
        ResultState = Object.assign({}, ResultState, {
          currentViewType: payload
        } as PenDispatcherT)
        break;
      case IPenContextEnum.tempData:
        let changedState = ResultState.tempData;
        let pens = ResultState.pens;
        (payload as ChangedAnimalData[]).forEach(newData => {
          let animalChangeIndex = changedState.findIndex(e => e.penId === newData.penId && e.animalId === newData.animalId)
          if (animalChangeIndex >= 0) {
            changedState[animalChangeIndex].data = Object.assign({}, changedState[animalChangeIndex].data, newData.data)
            if (newData.data.location !== undefined && isNaN(newData.data.location)) {
              pens = pens.map((pen) => {
                if (pen.location_id !== newData.penId) {
                  return pen;
                }
                return { ...pen, animals: pen.animals.filter((animal) => animal.animal_id !== newData.animalId) }
              })
            }
          }
          else changedState.push(newData);
        })
        ResultState = Object.assign({}, ResultState, {
          tempData: [...changedState],
          pens
        } as PenDispatcherT)
        break;
      case IPenContextEnum.replaceTempData:
        ResultState = Object.assign({}, ResultState, { tempData: payload })
        break
      case IPenContextEnum.error:
        ResultState = Object.assign({}, ResultState, {
          error: payload
        } as PenDispatcherT)
        break;
      case IPenContextEnum.pens:
        ResultState = Object.assign({}, ResultState, { pens: payload });
        break;
        case IPenContextEnum.systemState:
          ResultState = Object.assign({}, ResultState, { systemState: payload });
          break;
      default:
        console.error(`Unhandled action type: ${type}`)
        break
    }
  })
  return ResultState;
}

export const usePenContext = () => {
  const context = useContext(PenContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
};
